import React, { useRef } from "react";
import { Tabs, TabsContent } from "@racoon/ui";
import { useAnalyticsFilters } from "../model/useAnalyticsFilters";
import { AnalyticsFilters } from "../components/AnalyticsFilters";
import { AnalyticsCharts } from "../components/AnalyticsCharts";
import { AnalyticsReports } from "../components/AnalyticsReports";
import type { ReportTableHandle } from "../components/report-table";

export default function AnalyticsPage() {
  const {
    // State
    activeTab,
    activeReportTab,
    category,
    startDate,
    endDate,

    // Handlers
    handleTabChange,
    handleReportTabChange,
    handleCategoryChange,
    handleStartDateChange,
    handleEndDateChange,
  } = useAnalyticsFilters();

  // The active report; export and print exist on the reports tab only.
  const reportsRef = useRef<ReportTableHandle>(null);
  const handleDownloadExcel = async () => reportsRef.current?.handleDownloadExcel();
  const handleDownloadPdf = async () => reportsRef.current?.handleDownloadPdf();
  const handlePrint = () => reportsRef.current?.handlePrint();

  return (
    <div className="w-full flex flex-col md:h-[calc(100dvh-2rem)]">
      <Tabs value={activeTab} onValueChange={handleTabChange} className="md:h-full flex flex-col">
        <AnalyticsFilters
          activeTab={activeTab}
          activeReportTab={activeReportTab}
          category={category}
          startDate={startDate}
          endDate={endDate}
          onReportTabChange={handleReportTabChange}
          onCategoryChange={handleCategoryChange}
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
          onDownloadExcel={handleDownloadExcel}
          onDownloadPdf={handleDownloadPdf}
          onPrint={handlePrint}
        />

        <div className="min-h-0 flex-1 overflow-hidden">
          {/* Report tables */}
          <TabsContent value="reports" className="h-full !mt-0">
            <AnalyticsReports
              ref={reportsRef}
              activeReportTab={activeReportTab}
              startDate={startDate}
              endDate={endDate}
            />
          </TabsContent>

          {/* Charts */}
          <TabsContent value="charts" className="h-full !mt-0">
            <AnalyticsCharts startDate={startDate} endDate={endDate} category={category} />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
